import React, { Component } from 'react';
import { Carousel } from 'react-bootstrap';
import '../../styles/login.css';
import { imageBasePath } from '../../constants/staticData';

export default class CarouselSlider extends Component {
  render() {
    return (
      <div className="col-md-6 col-sm-6 col-xs-12 pad0">
        <div className="login-banner">
          <img
            className="login-banner-img"
            src={this.props.sliderImage ? this.props.sliderImage : `${imageBasePath}/business-sign-up-carcility.png`}
            alt={this.props.altTag?this.props.altTag:""}
          />
          <div className={this.props.pageType != 'signIn' ? 'sign-up-bg-text' : 'businessAuth-desc'}>
            <h5>{this.props.pageType != 'signIn' ? 'Meet new customers' : ''}</h5>
            <h1 className={this.props.pageType != 'signIn' ? '' : 'signIn-intro-text'}>
              {this.props.pageType != 'signIn'
                ? 'Carcility connect customers with auto repair need to your car workshop.'
                : 'Connect instantly with nearby customers in need of auto service.'}
            </h1>
            {this.props.pageType != 'signIn' &&
              this.props.pageType != 'signUp' &&
              <ul className="list-unstyled">
                <li>
                  <img src="images/tick_dark.png" className="tick-img" />
                  <span className="sub-title">Growth - </span>
                  <span className="sub-text">Increase your revenue by increasing your visibility.</span>
                </li>
                <li>
                  <img src="images/tick_dark.png" className="tick-img" />
                  <span className="sub-title">Build trust - </span>
                  <span className="sub-text">Get trusted online reviews and ratings.</span>
                </li>
                <li>
                  <img src="images/tick_dark.png" className="tick-img" />
                  <span className="sub-title">Automation - </span>
                  <span className="sub-text">Our services have your shops running 24/7</span>
                </li>
              </ul>}
            {this.props.pageType != 'signIn' &&
              this.props.pageType === 'signUp' &&
              <ul className="list-unstyled">
                <li>
                  {/*<i className="mdi mdi-check" />*/}
                  <img src="images/tick_dark.png" className="tick-img" />
                  <span className="sub-title-b">
                    Growth<br />
                    <span className="sub-text-b">Increase your revenue by increasing your visibility.</span>
                  </span>

                </li>
                <li>
                  <img src="images/tick_dark.png" className="tick-img" />
                  <span className="sub-title-b">
                    Build trust<br />
                    <span className="sub-text-b">Get trusted online reviews and ratings.</span>
                  </span>

                </li>
                <li>
                  <img src="images/tick_dark.png" className="tick-img" />
                  <span className="sub-title-b">
                    Automation<br />
                    <span className="sub-text-b">Our services have your shops running 24/7</span>
                  </span>
                </li>
              </ul>}
          </div>

        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/CarouselSlider.jsx